import { render } from "./PublicationAdvertisingSettings.vue.js?vue&type=template&id=03d138e2!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PublicationAdvertisingSettings.vue?vue&type=template&id=03d138e2"
import script from "./PublicationAdvertisingSettings.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PublicationAdvertisingSettings.vue?vue&type=script&lang=js"
export * from "./PublicationAdvertisingSettings.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PublicationAdvertisingSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/SharedWeb/scripts/components/advertising/PublicationAdvertisingSettings.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "03d138e2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('03d138e2', __exports__)) {
    api.reload('03d138e2', __exports__)
  }
  
  module.hot.accept("./PublicationAdvertisingSettings.vue.js?vue&type=template&id=03d138e2!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PublicationAdvertisingSettings.vue?vue&type=template&id=03d138e2", () => {
    api.rerender('03d138e2', render)
  })

}


export default __exports__